/* Herbaty — subtle scroll-reveal (progressive enhancement: without JS/IO everything stays visible) */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var sels = '.hb-bs__head, .hb-mush__head, .hb-reviews__head, .hb-journal__head, ' +
    '.hb-pcard, .hb-mcard, .hb-journal__card, .hb-comp__card, ' +
    '.hb-faq__item, .hb-contact__card';
  var els = document.querySelectorAll(sels);
  if (!els.length) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('is-in');
        io.unobserve(e.target);
        // clear the stagger delay once revealed so hover transitions aren't lagged
        setTimeout(function () { e.target.style.transitionDelay = ''; }, 900);
      }
    });
  }, { rootMargin: '0px 0px -7% 0px' });
  els.forEach(function (el, i) {
    el.classList.add('hb-rv');
    el.style.transitionDelay = (i % 4) * 70 + 'ms';
    io.observe(el);
  });
})();
